import React, {createContext, useReducer} from 'react';
import {
    SET_USER_PREFERENCES,
    SET_CURRENT_USER_INFO,
    SET_IS_REQUEST_IN_PROGRESS,
    TOGGLE_COMM_CHECKBOX,
    UPDATE_EXCLUDED_CHECKBOX_ARR,
    UPDATE_ALERTS_STATE_ARR,
    SET_ALERTS_LAST_QUERY_TIME,
    UPDATE_VMA_DROPDOWN_OPTIONS,
    UPDATE_VMA_LIST,
    SELECT_CONTROL_UNIT,
    SELECT_ORGANIZATION_ID,
    SET_LAST_CONTROL_UNIT_TIME_INTERVAL,
    SET_EDIT_MODE,
    SET_REMOTE_TABLE_LOADING,
    UPDATE_MULTI_SELECT_FILTER,
    INITIALIZE_MULTI_SELECT_FILTERS,
    SET_SORT_CARET_CLASS_NAME,
    SET_IS_FILTER_ENTER_KEY_PRESSED, SET_IS_PREPARING_EXCEL_DATA, SET_CU_UPDATE_DATE, SET_CU_CURRENT_VERSION, SET_CU_NEWEST_VERSION, SET_CU_DETAILS,
} from './ActionTypes/General/actionTypes'
import {DEFAULT_WATER_PRICE, UNKNOWN_USER_ID, CURRENT_USER_ID_COOKIE, STANDARD_USER} from "../Constants/constants";
import Cookies from "js-cookie";

const initialState = {
    userRole: STANDARD_USER,
    currentUserId: UNKNOWN_USER_ID,
    volumeMeasUnitOptions: 'liters',
    currencyUnits: "ILS",
    waterPrice: DEFAULT_WATER_PRICE
};

const store = createContext(initialState);
const {Provider} = store;

const StateProvider = ({children}) => {
    const [state, dispatch] = useReducer((state, action) => {
        switch (action.type) {
            case SET_CURRENT_USER_INFO:
                Cookies.set(CURRENT_USER_ID_COOKIE, action.payload.currentUserId, {secure: true, expires: 1 /* day */});
                return {
                    ...state,
                    userRole: action.payload.userRole,
                    currentUserId: action.payload.currentUserId,
                    email: action.payload.email
                }
            case SET_USER_PREFERENCES:
                return {
                    ...state,
                    volumeMeasUnitOptions: action.payload.volumeMeasUnitOptions,
                    currencyUnits: action.payload.currencyUnits,
                    waterPrice: action.payload.waterPrice
                }
            case  SET_IS_REQUEST_IN_PROGRESS:
                return {
                    ...state, isRequestInProgress: action.payload.isRequestInProgress
                }
            case  SET_ALERTS_LAST_QUERY_TIME:
                return {
                    ...state, lastQueryTime: action.payload.lastQueryTime
                }
            case TOGGLE_COMM_CHECKBOX:
                return {
                    ...state, isCheckboxDisabled: action.payload.isCheckboxDisabled
                }
            case UPDATE_EXCLUDED_CHECKBOX_ARR:
                return {
                    ...state, ['isExcludedCheckboxDisabledArr']: action.payload
                }
            case UPDATE_ALERTS_STATE_ARR:
                return {
                    ...state, ['alertsStateArr']: action.payload
                }
            case UPDATE_VMA_DROPDOWN_OPTIONS:
                return {
                    ...state, ['dropdownOptionsArr']: action.payload
                }
            case UPDATE_VMA_LIST:
                return {
                    ...state, ['vmaListArr']: action.payload
                }
            case SELECT_CONTROL_UNIT:
                return {
                    ...state, ['ControlUnit']: action.payload
                }
            case SELECT_ORGANIZATION_ID:
                return {
                    ...state, ['organizationId']: action.payload
                }
            case SET_LAST_CONTROL_UNIT_TIME_INTERVAL:
                return {
                    ...state, ['lastControlUnitTimeInterval']: action.payload
                }
            case SET_EDIT_MODE:
                return {
                    ...state, ['editMode']: action.payload
                }
            case SET_REMOTE_TABLE_LOADING:
                return {
                    ...state, ['isRemoteTableLoading']: action.payload
                }
            case SET_IS_PREPARING_EXCEL_DATA:
                return {
                    ...state, ['isPreparingExcelData']: action.payload
                }
            case INITIALIZE_MULTI_SELECT_FILTERS:
                const initializedFilters = action.payload.reduce((acc, filterKey) => {
                    acc[filterKey] = [];
                    return acc;
                }, {});
                return {
                    ...state,
                    multiSelectFilters: {
                        ...state.multiSelectFilters,
                        ...initializedFilters
                    }
                }
            case UPDATE_MULTI_SELECT_FILTER:
                return {
                    ...state,
                    multiSelectFilters: {
                        ...state.multiSelectFilters,
                        [action.payload.filterKey]: action.payload.items
                    }
                }
            case SET_SORT_CARET_CLASS_NAME:
                if (!state.isFilterEnterKeyPressed) {
                    return {
                        ...state,
                        columnSorts: {
                            ...state.columnSorts,
                            [action.payload.columnSorts.column]: action.payload.columnSorts.sortClass
                        }
                    }
                }
                return state;
            case SET_IS_FILTER_ENTER_KEY_PRESSED:
                return {
                    ...state, ['isFilterEnterKeyPressed']: action.payload
                }
            case SET_CU_UPDATE_DATE:
                return {
                    ...state, ['cuUpdateDate']: action.payload
                }
            case SET_CU_CURRENT_VERSION:
                return {
                    ...state, ['cuCurrentVersion']: action.payload
                }
            case SET_CU_NEWEST_VERSION:
                return {
                    ...state, ['cuNewestVersion']: action.payload
                }
            case SET_CU_DETAILS:
                return {
                    ...state, ['cuDetails']: action.payload
                }
            default:
                throw new Error();
        }
    }, initialState);

    return <Provider value={{state, dispatch}}>{children}</Provider>;
};

export {store, StateProvider}
